import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { formatValue, matchPlayColorScheme } from "./MatchPlayCard";
import { HelpBadge } from "./HelpBadge";

export function MatchPlayTeamResultsTable({ teamsData, ball2 }) {
  const yourTeamComparation = ball2
    ? teamsData?.find((team) => team.playerTeam)?.data.matches2
    : teamsData?.find((team) => team.playerTeam)?.data.matches;

  const totalScore =
    yourTeamComparation?.reduce((acc, curr) => {
      const score = curr.front9.score + curr.back9.score + curr.big18.score;
      return acc + score;
    }, 0) || 0;

  return (
    teamsData && (
      <>
        <table className="Table">
          <thead>
            <tr>
              <th>
                <Text as="C1" ta="center" bold style={{ color: "#8E9191" }}>
                  VS
                </Text>
              </th>
              {yourTeamComparation?.map((team) => (
                <th key={team.teamName}>
                  <Text as="C1" ta="center" bold style={{ color: "black" }}>
                    {team.name}
                  </Text>
                </th>
              ))}
              <th>
                <Text as="C1" ta="center" bold style={{ color: "#8E9191" }}>
                  TOTAL
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td />
              {yourTeamComparation?.map((team) => {
                const { front9, back9, big18 } = team;
                const findTeamWaysScore =
                  front9.score + back9.score + big18.score ?? "-";

                return (
                  <td key={team.teamId}>
                    <div className="Table-score">
                      <Text as="C1" bold style={{ color: "#8E9191" }}>
                        F9:
                      </Text>
                      <Text as="C1" bold style={{ color: "#5C6363" }}>
                        {formatValue({ value: team?.front9.margin })}
                        {/* {team?.front9.margin ?? "-"} */}
                      </Text>
                    </div>

                    <div className="Table-score">
                      <Text as="C1" bold style={{ color: "#8E9191" }}>
                        B9:
                      </Text>
                      <Text as="C1" bold style={{ color: "#5C6363" }}>
                        {formatValue({ value: team?.back9.margin })}
                        {/* {team?.back9.margin ?? "-"} */}
                      </Text>
                    </div>

                    <div className="Table-score">
                      <Text as="C1" bold style={{ color: "#8E9191" }}>
                        18:
                      </Text>
                      <Text as="C1" bold style={{ color: "#5C6363" }}>
                        {formatValue({ value: team?.big18.margin })}
                        {/* {team?.big18.margin ?? "-"} */}
                      </Text>
                    </div>

                    {team?.front9.presses.length > 0 && (
                      <div className="Table-score">
                        <Text as="C1" bold style={{ color: "#8E9191" }}>
                          F9P:
                        </Text>
                        <Text as="C1" bold style={{ color: "#5C6363" }}>
                          {formatValue({
                            value: team?.front9.presses[0].margin || 0,
                          })}
                          {/* {team?.front9.presses[0].margin ?? "-"} */}
                        </Text>
                      </div>
                    )}

                    {team?.back9.presses.length > 0 && (
                      <div className="Table-score">
                        <Text as="C1" bold style={{ color: "#8E9191" }}>
                          B9P:
                        </Text>
                        <Text as="C1" bold style={{ color: "#5C6363" }}>
                          {formatValue({
                            value: team?.back9.presses[0].margin || 0,
                          })}
                          {/* {team?.back9.presses[0].margin ?? "-"} */}
                        </Text>
                      </div>
                    )}

                    <div className="Table-scoreDivider" />

                    <Text
                      ta="center"
                      as="H3"
                      bold
                      style={{
                        color:
                          matchPlayColorScheme(findTeamWaysScore)
                            .valueFontColor,
                      }}
                    >
                      {formatValue({ value: findTeamWaysScore })}
                    </Text>
                  </td>
                );
              })}
              <td>
                <Text
                  ta="center"
                  as="H3"
                  bold
                  style={{
                    color: matchPlayColorScheme(totalScore).valueFontColor,
                  }}
                >
                  {formatValue({ value: totalScore })}
                </Text>
              </td>
            </tr>
          </tbody>
          {/* <tfoot>
            <tr>
              <td colSpan={teamsData.length + 2}>
                <button>Добавить команду</button>
              </td>
            </tr>
          </tfoot> */}
        </table>
        <HelpBadge />
      </>
    )
  );
}

MatchPlayTeamResultsTable.propTypes = {
  ball2: PropTypes.bool.isRequired,
  teamsData: PropTypes.shape({
    find: PropTypes.func,
  }).isRequired,
};
